import { Color } from "@constants/V2/color"
import { getComponentColorTheme } from "@utils/V2/color"

export interface PaymentStrips {
  paymentStripDark?: Storyblok.Asset
  paymentStripLight?: Storyblok.Asset
}

/**
 * Returns the correct payment strip object based on background color and available strips.
 * @param paymentStrips The light and dark payment strip assets
 * @param backgroundColor The background color to determine theme (optional)
 * @param lightPaymentStripOverride The override for the light payment strip (optional)
 */
export function getPaymentStrip(
  paymentStrips: PaymentStrips,
  backgroundColor?: string,
  lightPaymentStripOverride?: { filename?: string }
): { filename?: string } | undefined {
  if (paymentStrips.paymentStripLight && paymentStrips.paymentStripDark) {
    return getComponentColorTheme(
      (backgroundColor as Color) ?? Color.Charcoal
    ) === "dark"
      ? (lightPaymentStripOverride ?? paymentStrips.paymentStripLight)
      : paymentStrips.paymentStripDark
  }
  return undefined
}
